import { lazy, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Cargando } from './comun/Cargando';
import { Logo } from './comun/Marca';
import { resolverZona, ZONA_DESCRIPCION, ZONA_TITULO, ZONAS } from './zonas';

/*
 * Cada zona se carga por separado a proposito. Un candidato que abre su
 * formulario no debe descargar el codigo del backoffice, y un cliente tampoco.
 * La separacion es de seguridad, no solo de peso.
 */
const RutasGestion = lazy(() => import('./gestion/RutasGestion'));
const RutasPedidos = lazy(() => import('./pedidos/RutasPedidos'));
const RutasSolicitud = lazy(() => import('./solicitud/RutasSolicitud'));

export function App() {
  const resuelta = resolverZona();

  if (!resuelta) return <Portada />;

  return (
    <BrowserRouter basename={resuelta.basename}>
      <Suspense fallback={<Cargando />}>
        {resuelta.zona === 'gestion' && <RutasGestion />}
        {resuelta.zona === 'pedidos' && <RutasPedidos />}
        {resuelta.zona === 'solicitud' && <RutasSolicitud />}
      </Suspense>
    </BrowserRouter>
  );
}

/**
 * Solo se ve entrando por la raiz sin subdominio, que es como se accede
 * mientras no existan los DNS. Con los subdominios en su lugar, cada zona
 * responde directo y esta pantalla deja de aparecer.
 */
function Portada() {
  return (
    <div className="grid min-h-full place-items-center bg-marca-50 p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <Logo className="h-20 w-auto" />
          <h1 className="mt-4 text-lg font-semibold text-marca-700">
            Socioambientales DM
          </h1>
          <p className="mt-1 text-sm text-slate-500">
            Elige por dónde quieres entrar.
          </p>
        </div>

        <ul className="space-y-2">
          {ZONAS.map((z) => (
            <li key={z}>
              <a
                href={`/${z}`}
                className="flex items-center justify-between rounded-xl bg-white px-5 py-4 shadow-sm ring-1 ring-black/5 transition hover:ring-marca-300"
              >
                <span>
                  <span className="block font-medium text-slate-900">
                    {ZONA_TITULO[z]}
                  </span>
                  <span className="block text-sm text-slate-500">
                    {ZONA_DESCRIPCION[z]}
                  </span>
                </span>
                <span aria-hidden className="text-slate-300">
                  →
                </span>
              </a>
            </li>
          ))}
        </ul>

        <p className="mt-6 text-center text-xs text-slate-400">
          Cada zona tendrá su propio subdominio. Mientras tanto se accede por
          ruta.
        </p>
      </div>
    </div>
  );
}
